module.exports = __webpack_public_path__ + "static/media/circle-check.44e71c2f.svg";